import moment from 'moment';

export const printStatus = (status, pickup_to = null) => {
  switch (status) {
    case 0:
      if (moment().unix() <= moment(pickup_to).unix() && pickup_to) {
        return 'PENDING';
      }
      return 'NON PICKED UP';
    case 1:
      return 'PICKED UP';
    case 2:
      return 'Cancelled by consumer';
    case 3:
      return 'Cancelled by store';
    case 4:
      return 'Ready for pick up';
    default:
      return 'CANCELLED';
  }
}

export const isToday = (from, momentDate) => {
  const REFERENCE = moment.unix(from);
  const TODAY = REFERENCE.clone().startOf('day');
  return moment.unix(momentDate).isSame(TODAY, 'd');
}

export default {
  printStatus,
  isToday,
}